import gql from 'graphql-tag';
import { RelatedArticlesSectionFragment } from './blog-education-center';
import { UrlCtaFragment } from './fragments';

export const RealEstateMarketingLandingPageQuery = gql`
	query RealEstateMarketingLandingPage {
		allRealEstateLandingPage {
			realEstateStrategiesShowcase {
				heading
				summary
				showcaseLink {
					...UrlCtaFragment
				}
				strategyStats {
					value
					label
				}
				strategyImages {
					asset {
						url
						altText
					}
				}
			}
			showcaseSectionDisclaimer
			assetsHeading
			assetsSummary
			relatedArticlesSection: relatedArticles {
				...RelatedArticlesSectionFragment
			}
			ctaPanelHeading
		}
	}
	${RelatedArticlesSectionFragment}
	${UrlCtaFragment}
`;
